module.exports = __webpack_public_path__ + "img/31.911f6382.png";